import { useNavigate } from "react-router-dom";
import { Grid, Typography, TextField, Button, Box, FormControl, InputLabel, Select } from "@mui/material";//FB 8881
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MenuItem from '@mui/material/MenuItem';//FB 8881
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import UseStyle from "../../../css/styles";
import { useState, useEffect } from "react";
import { Patient } from "../../../store";
import {GetAdminSettingValue } from "../../../api";//FB 8881
import { format } from "date-fns";
import useMediaQuery from "@mui/material/useMediaQuery";
import { SearchPatient } from "../../../api/PE_API";//FB 8881


// Update log
// FB  8099   01/17/2024  SK   Add Support to Patient Portal to Facilitate Patients Seeing their Invoices and Optionally being able to Pay
// FB  8881   06/14/2024  SK   Show Billing Details in Portal for All Patients in Guest Login Interface
// FB  8936   07/02/2024  KI   Hide "Pay this" Column in Billing Screen if CALLIPAY_API_KEY is empty

export default function GuestLogin() {
    const matches = useMediaQuery("(min-width:600px)");
    const navigate = useNavigate();
    var JSAlert = require("js-alert");
    const styles = UseStyle();
    const theme = createTheme({
      palette: {
        primary: {
          main: "#18a2b8",
        },
      },
    });
    var intialState: Patient = {} as Patient;
    intialState.PatientDOB = null as unknown as Date;
    const [fields, setFields] = useState(intialState);
    const [errors, setErrors] = useState<any>({});
    const handleDateChange = async (date: any) => {
      if (date != null && date != "Invalid Date") {
        handleInputChange(date);
      }
    };
    const handleInputChange = (e: any) => {
      if (!isNaN(Date.parse(e))) {
        setErrors({ PatientDOB: false });
        setFields({
          ...fields,
          PatientDOB: e,
        });
      } else {
        setErrors({ [e.target.name]: false });
        setFields({
          ...fields,
          [e.target.name]: e.target.value,
        });
      }
    };
  
    function Validate() {
      if (fields.PatientFirstName == undefined || fields.PatientFirstName === "") {
        setErrors((errors: any) => ({ ...errors, PatientFirstName: true }));
        return false;
      }
      if (fields.PatientDOB == undefined || fields.PatientDOB.toString() == "") {
        setErrors((errors: any) => ({ ...errors, PatientDOB: true }));
        return false;
      }
      if (fields.PatientZIP == undefined || fields.PatientZIP === "") {
        setErrors((errors: any) => ({ ...errors, PatientZIP: true }));
        return false;
      }
      return true;
    }
  
    const handleSubmit = async (e: any) => {
      e.preventDefault();
      if (Validate()) {
        const result = await SearchPatient(fields);//FB 8881
		//FB 8936
        if (!result || result.length === 0) {
        JSAlert.alert("No patient information found.", null, JSAlert.Icons.Failed);
		} else if (result.alertType === "Failed") {
			JSAlert.alert(result.message, null, JSAlert.Icons.Failed);
		} else {
			sessionStorage.setItem("PatientInfo", result[0].Id); //FB 8881
			navigate("/user/guestBilling");
		}
      }
    };
  
    const [HeaderText, setHeaderText] = useState("");
  
    async function LoadHeaderText() {
      let setting = await GetAdminSettingValue("LicenseeName");
      if (setting != null) {
        setHeaderText(setting);
      }
    }
  
    useEffect(() => {
      LoadHeaderText();
    }, []);
  
    return (
      <form onSubmit={handleSubmit}>
        <Grid container spacing={1} flexDirection="column">
          <Grid
            item
            xs={12}
            style={{
              backgroundColor: "#F5F5F5",
              minHeight: "75px",
              alignItems: "center",
              display: "flex",
              paddingLeft: matches == false ? "20px" : "90px",
            }}
          >
            <Typography variant="h5" style={{ backgroundColor: "#F5F5F5" }}>
              <b>Guest Login</b>{/* FB 8881 */}
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            <Typography variant="h6">
              <b>Verification</b>
            </Typography>
          </Grid>
  
          <Grid
            item
            xs={12}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            <Typography variant="body1">
              Please verify patient information to view invoice and pay the bills
            </Typography>
            <hr />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <TextField
              id="PatientFirstName"
              name="PatientFirstName"
              label="Patient First Name"
              value={fields.PatientFirstName}
              onChange={handleInputChange}
              error={errors.PatientFirstName}
              variant="outlined"
              required
              fullWidth
            />
          </Grid>
  
          <br></br>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <TextField
              id="PatientLastName"
              name="PatientLastName"
              label="Patient Last Name"
              value={fields.PatientLastName}
              onChange={handleInputChange}
              error={errors.PatientFirstName}
              variant="outlined"
              required
              fullWidth
            />
          </Grid>
  
          <br></br>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <ThemeProvider theme={theme}>
                <KeyboardDatePicker
                  InputLabelProps={{ shrink: true }}
                  className={styles.datepickerroot}
                  id="PatientDOB"
                  name="PatientDOB"
                  label="Date of Birth"
                  value={fields.PatientDOB}
                  format="MM/dd/yyyy"
                  placeholder="MM/dd/yyyy"
                  openTo="year"
                  views={["year", "month", "date"]}
                  onChange={(date) => handleDateChange(date)}
                  inputVariant="standard"
                  orientation="portrait"
                  disableFuture
                  required
                  fullWidth
                />
              </ThemeProvider>
            </MuiPickersUtilsProvider>
          </Grid>
          <br></br>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
            <TextField
              id="PatientZIP"
              name="PatientZIP"
              label="ZIP"
              value={fields.PatientZIP}
              onChange={handleInputChange}
              error={errors.PatientZIP}
              variant="outlined"
              fullWidth
              required
            />
            {/* FB 8881 - Begin */}
          </Grid>
          <br/>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
            lg={4}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              paddingRight: matches == false ? "16px" : "",
            }}
          >
           <FormControl
              fullWidth
            >
              <InputLabel id="demo-simple-select-label">Gender</InputLabel>
              {/* FB 8936 added required field moved the comment*/}
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                name="PatientGender"
                label="Gender"
                value={fields.PatientGender}
                onChange={handleInputChange}
				        required
              >
                  <MenuItem value={1}>Male</MenuItem>
                  <MenuItem value={2}>Female</MenuItem>
				  {/* FB 8936 */}
				  <MenuItem value={3}>Unknown</MenuItem>
              </Select>
            </FormControl>
            {/* FB 8881 - End */}
          </Grid>
          <Grid item xs={6} sm={3} md={2}>
            {" "}
            <Button
              type="submit"
              variant="contained"
              className={styles.navigationButton}
              style={{
                marginLeft: matches == false ? "16px" : "80px",
                marginTop: "20px",
                marginBottom: "60px",
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </form>
    );
  }
  